import {
  DragIndicator,
  ExpandLess,
  ExpandMore,
  Settings,
} from "@material-ui/icons";
import React, { useState } from "react";
import {
  Container,
  DropDownSection,
  ExpandButton,
  ExpandContainer,
  GroupItem,
  GroupName,
  GroupsList,
  Header,
  PackageCommitteeHeader,
  PackageCommitteeItem,
  PackageCommitteeName,
  PackageCommitteesContainer,
  PackageDragButton,
  SettingsButton,
  SettingsContainer,
} from "./styles";

interface IGroupCardProps {
  group: {
    id: string;
    active: boolean;
    name: string;
    committeePackage: {
      active: boolean;
      id: string;
      name: string;
      committees: {
        id: string;
        activated: boolean;
        name: string;
      }[];
    };
  };
}

const GroupCard: React.FC<IGroupCardProps> = ({ group }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Container active={group.active}>
      <Header>
        <GroupName>{group.name}</GroupName>

        <SettingsContainer>
          <SettingsButton
            to={`/system-management/configure-groups?id=${group.id}`}
          >
            <Settings />
          </SettingsButton>
        </SettingsContainer>
      </Header>

      <PackageCommitteesContainer>
        <PackageCommitteeItem>
          <PackageCommitteeHeader
            onClick={() => setExpanded((oldValue) => !oldValue)}
          >
            <PackageDragButton>
              <DragIndicator />
            </PackageDragButton>

            <PackageCommitteeName
              active={group.committeePackage.active}
              to={`/system-management/configure-committee-packages?id=${group.committeePackage.id}`}
            >
              {group.committeePackage.name}
            </PackageCommitteeName>

            <ExpandContainer>
              <ExpandButton>
                {expanded ? <ExpandLess /> : <ExpandMore />}
              </ExpandButton>
            </ExpandContainer>
          </PackageCommitteeHeader>

          {expanded && (
            <DropDownSection>
              <GroupsList>
                {group.committeePackage.committees.map((committee) => (
                  <GroupItem active={committee.activated}>
                    {committee.name}
                  </GroupItem>
                ))}
              </GroupsList>
            </DropDownSection>
          )}
        </PackageCommitteeItem>
      </PackageCommitteesContainer>
    </Container>
  );
};

export default GroupCard;
